import update from 'immutability-helper'

import {
  // PLOP_APPEND_PATTERN_ANCHOR_ACTIONS_IMPORT
  CREATE_GAM_LINE_ITEM_FORECAST,
  CREATE_GAM_LINE_ITEM_FORECAST_SUCCESS,
  CREATE_GAM_LINE_ITEM_FORECAST_FAILURE,
  CLEAR_CREATE_GAM_LINE_ITEM_FORECAST,
  GET_GAM_AD_UNIT_SIZES,
  GET_GAM_AD_UNIT_SIZES_SUCCESS,
  GET_GAM_AD_UNIT_SIZES_FAILURE,
  CLEAR_GET_GAM_AD_UNIT_SIZES,
  CREATE_BULK_GAM_LINE_ITEMS,
  CREATE_BULK_GAM_LINE_ITEMS_SUCCESS,
  CREATE_BULK_GAM_LINE_ITEMS_FAILURE,
  CLEAR_CREATE_BULK_GAM_LINE_ITEMS,
  GET_ONSITE_RATES,
  GET_ONSITE_RATES_SUCCESS,
  GET_ONSITE_RATES_FAILURE,
  CLEAR_GET_ONSITE_RATES,
  GET_GOOGLE_AD_MANAGER_AD_UNIT,
  GET_GOOGLE_AD_MANAGER_AD_UNIT_SUCCESS,
  GET_GOOGLE_AD_MANAGER_AD_UNIT_FAILURE,
  CLEAR_GET_GOOGLE_AD_MANAGER_AD_UNIT,
  GET_GOOGLE_AD_MANAGER_AD_UNITS,
  GET_GOOGLE_AD_MANAGER_AD_UNITS_SUCCESS,
  GET_GOOGLE_AD_MANAGER_AD_UNITS_FAILURE,
  CLEAR_GET_GOOGLE_AD_MANAGER_AD_UNITS
} from '../actions/googleAdManager'
import { INITIAL_CREATE_REDUCER, INITIAL_GET_REDUCER, INITIAL_GET_RESULTS_REDUCER } from '../../constants/reducer'

const initialState = {
  // PLOP_APPEND_PATTERN_ANCHOR_INITIAL_REDUCER
  createGamLineItemForecast: INITIAL_CREATE_REDUCER,
  googleAdManagerAdUnits: INITIAL_GET_RESULTS_REDUCER,
  googleAdManagerAdUnit: INITIAL_GET_REDUCER,
  onsiteRates: INITIAL_GET_RESULTS_REDUCER,
  createBulkGamLineItems: INITIAL_CREATE_REDUCER,
  getGamAdUnitSizes: INITIAL_GET_RESULTS_REDUCER
}

export default function googleAdManager(state = initialState, action) {
  switch (action.type) {
    // PLOP_APPEND_PATTERN_ANCHOR_REDUCERS

    // Get google ad manager ad units
    case GET_GOOGLE_AD_MANAGER_AD_UNITS:
      return update(state, {
        googleAdManagerAdUnits: { $merge: { isLoading: true } }
      })
    case GET_GOOGLE_AD_MANAGER_AD_UNITS_SUCCESS:
      return update(state, {
        googleAdManagerAdUnits: {
          $merge: {
            isLoading: false,
            wasLoaded: true,
            results: action.data
          }
        }
      })
    case GET_GOOGLE_AD_MANAGER_AD_UNITS_FAILURE:
      return update(state, {
        googleAdManagerAdUnits: {
          $merge: {
            isLoading: false,
            error: action.error
          }
        }
      })
    case CLEAR_GET_GOOGLE_AD_MANAGER_AD_UNITS:
      return update(state, {
        googleAdManagerAdUnits: { $set: initialState.googleAdManagerAdUnits }
      })

    // Get google ad manager ad unit
    case GET_GOOGLE_AD_MANAGER_AD_UNIT:
      return update(state, {
        googleAdManagerAdUnit: { $merge: { isLoading: true } }
      })
    case GET_GOOGLE_AD_MANAGER_AD_UNIT_SUCCESS:
      return update(state, {
        googleAdManagerAdUnit: {
          $merge: {
            isLoading: false,
            wasLoaded: true,
            data: action.data
          }
        }
      })
    case GET_GOOGLE_AD_MANAGER_AD_UNIT_FAILURE:
      return update(state, {
        googleAdManagerAdUnit: {
          $merge: {
            isLoading: false,
            error: action.error
          }
        }
      })
    case CLEAR_GET_GOOGLE_AD_MANAGER_AD_UNIT:
      return update(state, {
        googleAdManagerAdUnit: { $set: initialState.googleAdManagerAdUnit }
      })

    // Get onsite rates
    case GET_ONSITE_RATES:
      return update(state, {
        onsiteRates: { $merge: { isLoading: true } }
      })
    case GET_ONSITE_RATES_SUCCESS:
      return update(state, {
        onsiteRates: {
          $merge: {
            isLoading: false,
            wasLoaded: true,
            results: action.data.results
          }
        }
      })
    case GET_ONSITE_RATES_FAILURE:
      return update(state, {
        onsiteRates: {
          $merge: {
            isLoading: false,
            error: action.error
          }
        }
      })
    case CLEAR_GET_ONSITE_RATES:
      return update(state, {
        onsiteRates: { $set: initialState.onsiteRates }
      })

    // Create bulk gam line items
    case CREATE_BULK_GAM_LINE_ITEMS:
      return update(state, {
        createBulkGamLineItems: { $merge: { isLoading: true } }
      })
    case CREATE_BULK_GAM_LINE_ITEMS_SUCCESS:
      return update(state, {
        createBulkGamLineItems: {
          $merge: {
            isLoading: false,
            wasCreated: true,
            data: action.data
          }
        }
      })
    case CREATE_BULK_GAM_LINE_ITEMS_FAILURE:
      return update(state, {
        createBulkGamLineItems: {
          $merge: {
            isLoading: false,
            error: action.error
          }
        }
      })
    case CLEAR_CREATE_BULK_GAM_LINE_ITEMS:
      return update(state, {
        createBulkGamLineItems: { $set: initialState.createBulkGamLineItems }
      })
    // Get gam ad units
    case GET_GAM_AD_UNIT_SIZES:
      return update(state, {
        getGamAdUnitSizes: { $merge: { isLoading: true } }
      })
    case GET_GAM_AD_UNIT_SIZES_SUCCESS:
      return update(state, {
        getGamAdUnitSizes: {
          $merge: {
            isLoading: false,
            wasLoaded: true,
            results: action.data
          }
        }
      })
    case GET_GAM_AD_UNIT_SIZES_FAILURE:
      return update(state, {
        getGamAdUnitSizes: {
          $merge: {
            isLoading: false,
            error: action.error
          }
        }
      })
    case CLEAR_GET_GAM_AD_UNIT_SIZES:
      return update(state, {
        getGamAdUnitSizes: { $set: initialState.getGamAdUnitSizes }
      })

    // Create gam line item forecast
    case CREATE_GAM_LINE_ITEM_FORECAST:
      return update(state, {
        createGamLineItemForecast: { $merge: { isLoading: true } }
      })
    case CREATE_GAM_LINE_ITEM_FORECAST_SUCCESS:
      return update(state, {
        createGamLineItemForecast: {
          $merge: {
            isLoading: false,
            wasCreated: true,
            data: action.data
          }
        }
      })
    case CREATE_GAM_LINE_ITEM_FORECAST_FAILURE:
      return update(state, {
        createGamLineItemForecast: {
          $merge: {
            isLoading: false,
            error: action.error
          }
        }
      })
    case CLEAR_CREATE_GAM_LINE_ITEM_FORECAST:
      return update(state, {
        createGamLineItemForecast: { $set: initialState.createGamLineItemForecast }
      })

    default:
      return state
  }
}
